import MathTool from "../math/MathTool";

export class Repulsor{
    constructor( x, y, radius,  ){
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    
    getForceVector( point ){
        let repulsorPoint = { x:this.x, y:this.y };
        let dist = MathTool.distance( repulsorPoint, point );
        if( dist < this.radius ){
            let vector = { x:point.x-repulsorPoint.x, y:point.y-repulsorPoint.y };
            let angle = Math.atan2( vector.x, vector.y );
            let vx = Math.sin(angle);
            let vy = Math.cos(angle);
            let invD = this.radius-dist;

            let result = {
                x: vx*(invD/this.radius)*(invD/this.radius),
                y: vy*(invD/this.radius)*(invD/this.radius)
            };
            //console.log( "result: ", result );
            return result;
            
            let normDistance = dist/this.radius;
            let force = -normDistance; // Inverse of distance, normalized to 0-1

            let forceX = Math.cos( angle )*force;
            let forceY = Math.sin( angle )*force;
            return {x: forceX, y: forceY};
        }
        return {x: 0, y: 0};

    }
}